import React from 'react';
import Container from './container';

type AuthRouteProps = {
  component: React.ComponentType<any>;
  title: string;
} 

const AuthRoute = (props: AuthRouteProps): JSX.Element => {
  const {title, component: Component} = props;
  return (
    <Container title={title}>
      <Component />
    </Container>
  );
}

export default AuthRoute;
